import { api } from '@/api';

export interface Institution {
  id: string;
  name: string;
  logo: string;
}

export interface InitConnectionParams {
  institutionId: string;
  reference: string;
  user_language: string;
}

export interface InitConnectionResponse {
  link?: string;
}

/**
 * Service for managing bank connections via GoCardless
 */
class BankConnectionsService {
  /**
   * Get list of available institutions for a country
   */
  async getInstitutions(country: string): Promise<Institution[]> {
    const result = await api.v1['bank-connections'].institutions.get({
      query: { country },
    });
    return (result.data as Institution[]) || [];
  }

  /**
   * Initialize a bank connection
   */
  async initConnection(
    params: InitConnectionParams
  ): Promise<InitConnectionResponse> {
    const result =
      await api.v1['bank-connections']['init-connection'].post(params);
    if (result.error) throw result.error;
    return result.data as InitConnectionResponse;
  }

  /**
   * Delete/disconnect a bank connection
   */
  async deleteBankConnection(id: string): Promise<{ success: boolean }> {
    const result = await api.v1['bank-connections']?.({ id }).delete();
    if (result?.error) throw result.error;
    return result?.data as { success: boolean };
  }
}

export const bankConnectionsService = new BankConnectionsService();
